/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import "@fontsource/montserrat/400.css"
import "@fontsource/montserrat/500.css"
import "@fontsource/montserrat/600.css"
import "@fontsource/montserrat/900.css"
import "@fontsource/noto-serif/400.css"
import "@fontsource/inter"
import "@fontsource/encode-sans"

import "./src/styles/global.css"

export const onClientEntry = () => {
  console.log("Client entry")
}

export const onRouteUpdate = () => {
  console.log("Route updated")
}
